import { render, staticRenderFns } from "./counterpartiesArchive.vue?vue&type=template&id=023b3182&scoped=true"
import script from "./counterpartiesArchive.vue?vue&type=script&lang=js"
export * from "./counterpartiesArchive.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesArchive.vue?vue&type=style&index=0&id=023b3182&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b3182",
  null
  
)

export default component.exports